<template>
	<div style="margin: 10px;">
		<el-card class="box-card">
			<el-row>
				<el-col :span="24">
					<h4 class="title">文章信息</h4>
					<el-form ref="form" :model="form" label-width="160px" :rules="rules">
						<!-- <el-form-item label="一级分类" prop="one">
							<el-select  v-model="form.one" placeholder="一级分类" @change="getOne" style="width: 30%;">
								<el-option :label="item.columname" :value="item.id" v-for="(item,index) in listOne" :key="item.id">{{item.columname}}</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="二级分类" size="mini"  v-show="twoShow">
							<el-select v-model="form.two" placeholder="二级分类" @change="getTwo($event,'two')" style="width: 30%;"  clearable>
								<el-option :label="item.columname" :value="item.id" v-for="(item,index) in listTwo" :key="item.id">{{item.columname}}</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="三级分类" size="mini"  v-show="threeShow">
							<el-select v-model="form.three" placeholder="三级分类"  clearable>
								<el-option :label="item.columname" :value="item.id" v-for="(item,index) in listThree" :key="item.id">{{item.columname}}</el-option>
							</el-select>
						</el-form-item> -->
						<el-form-item label="标题" prop="title">
							<el-input v-model="form.title" style="width: 30%;"></el-input>
						</el-form-item>

						<div class="line"></div>
						<h4 class="title">图片展示</h4>
						<el-form-item prop="pic">
							<!-- <el-input readonly v-model="form.pic" style="width:30%;float: left;"></el-input> -->
							<el-upload drag list-type="picture-card" action="" multiple :limit="1" :file-list="fileList"
								:before-upload="beforePic" :on-remove="RemovePic" :on-exceed="handlePic"
								style="width: auto;float: left;">

								<i class="el-icon-picture-outline"></i>
								<br />
								<span class="uploadTip">将图片拖到此处，或点击上传</span>
							</el-upload>
							<input type="button" size="mini" class="bullet"
								style="display: inline-block;margin-top:5px;float: left;margin: 10px;"
								@click.stop="dialogVisible = true" value="素材库选择">
								<div class="clear"></div>
							<span class="picTip" style="display: inline-block;">封面图（支持JPG、JPEG、PNG图片大小限制120K）</span>
							<!-- <img :src="settings.apiBaseImg+form.pic" alt="" v-if="form.pic"  style="width: 200px;height: 200px;margin-top: 10px;"> -->
						</el-form-item>

						<div class="line"></div>
						<h4 class="title"></h4>

						<el-form-item label="详细内容">
							<editor v-model="form.detail" :isClear="isClear" @change="change"></editor>
						</el-form-item>
						<el-form-item label="描述">
							<el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4}" placeholder="请输入内容"
								v-model="form.desc">
							</el-input>
						</el-form-item>
						<el-form-item label="状态" prop="resource">
							<el-radio-group v-model="form.resource">
								<el-radio :label="0" value="0">正常</el-radio>
								<el-radio :label="1" value="1">禁用</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item>
							<input type="button" class="submit" @click="onSubmit('form')" value="提交">
						</el-form-item>
					</el-form>
				</el-col>
			</el-row>
		</el-card>
		<!-- 素材库选择 -->
		<el-dialog title="素材库选择" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
			<files @selectPic="selectPic"></files>
		</el-dialog>
	</div>
</template>

<script>
import E from "wangeditor";
	// import EditorBar from '../../../components/editor.vue'
	import request from '../../../assets/js/request.js'
	import files from '../../../components/picFile.vue'
	import Editor from '../../../components/tinymce.vue'
	import qs from 'qs'
	export default {
		components: {
			Editor,
			files
		},
		data() {
			return {
				listOne: [],
				listTwo: [],
				listThree: [],
				form: {
					one: '',
					two: '',
					three: '',
					title: '',
					pic: '',
					detail: '',
					desc: '',
					imagesThumb: '',
					resource: '',
					id: '',

				},
				editorText:'',
				twoShow: false,
				threeShow: false,
				isClear: false,
				dialogVisible: false,
				rules: {
					pic: [{
						required: true,
						message: '请输入图片',
						trigger: 'blur'
					}],
					title: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}],
					// one: [{
					// 	required: true,
					// 	message: '请选择一级分类',
					// 	trigger: 'change'
					// }],
					// two: [{
					// 	required: true,
					// 	message: '请选择二级分类',
					// 	trigger: 'change'
					// }],
					// three: [{
					// 	required: true,
					// 	message: '请选择三级分类',
					// 	trigger: 'change'
					// }]
				},
				iden: '',
				fileList: []
			}
		},
		created() {
			// this.getType()
			this.iden = this.$route.query.iden
			if (this.iden == 'add') {
				this.form.resource = 0
				return;
			} else {
				this.getData()
			}
			//获取一级分类
		},
		mounted() {

		},
		methods: {
			//如果是编辑的话将数据回显
			getData() {
				var list = this.$route.query.rows
				this.form.title = list.title
				// this.form.one = list.oneCate
				// this.form.two = list.twoCate
				// this.form.three = list.threeCate
				this.form.pic = list.images
				this.form.imagesThumb = list.imagesThumb
				this.form.resource = list.status
				this.form.detail = list.content
				this.form.desc = list.brief
				this.form.resource = list.status
				this.form.id = list.id
				this.fileList.push({
					url: this.settings.apiBaseImg + list.images
				})
			},
			//获取分类
			getType() {
				var obj = this
				obj.$http({
					method: 'get',
					url: 'api/v1/news/column/one',
					params: {

					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.listOne = res.data.data
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			//二级分类
			getOne(event) {
				this.twoShow = true
				var obj = this
				obj.$http({
					method: 'get',
					url: 'api/v1/news/column/child',
					params: {

						id: event
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.listTwo = res.data.data
						if (this.$route.query.iden == 'update') {
							this.getTwo(this.form.two)
						}
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			//三级分类
			getTwo(event, type) {
				if (event == '') {
					this.form.three = ''
					return;
				}
				if (type != undefined) {
					this.form.three = ''
				}
				this.threeShow = true
				var obj = this
				obj.$http({
					method: 'get',
					url: 'api/v1/news/column/child',
					params: {

						id: event
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.listThree = res.data.data
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			beforePic(file, fileList) {
				let objUrl = file;
				let formData = new FormData();
				formData.append('file', objUrl);
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/news/upload',
					data: formData,
				}).then((res) => {
					if (res.status == 200) {
						obj.$message.success(res.data.message)
						this.form.pic = res.data.data.images
						this.form.imagesThumb = res.data.data.imagesThumb
						this.fileList = []
						this.fileList.push({
							url: this.settings.apiBaseImg +res.data.data.imagesThumb
						})
					} else {
						obj.$message.error(res.data.data.message)
					}
				})
			},
			//素材库选择图片
			selectPic(index, rows) {
				this.form.pic = rows.path
				this.fileList = []
				this.fileList.push({
					url: this.settings.apiBaseImg + rows.path
				})
				this.dialogVisible = false
			},
			change(val) {
				console.log(val)
			},
			RemovePic() {
				this.form.pic = ''
			},
			handlePic(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			//添加
			onSubmit(formName) {
				if (this.$route.query.iden == 'add') {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							var obj = this
							obj.$http({
								method: 'post',
								url: 'api/v2/news/add',
								data: {
									cid: this.$route.query.id,
									// oneCate: this.form.one,
									// twoCate: this.form.two,
									// threeCate	: this.form.three,
									title: this.form.title,
									status: this.form.resource,
									images: this.form.pic,
									imagesThumb: this.form.imagesThumb,
									content: this.form.detail,
									brief: this.form.desc,
								},
							}).then((res) => {
								if (res.data.status == 200) {
									this.$message.success('添加成功');
									this.$router.push({
										path: '/home/article',
										query: {
											id: this.$route.query.id
										}
									})
								} else {
									this.$message.error(res.data.message);
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else {
					this.onUpdate(formName)
				}
			},
			//修改
			onUpdate(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						var obj = this
						obj.$http({
							method: 'post',
							url: 'api/v2/news/update',
							data: {
								cid: this.$route.query.id,
								id: this.form.id,
								// oneCate: this.form.one,
								// twoCate: this.form.two,
								// threeCate	: this.form.three,
								title: this.form.title,
								status: this.form.resource,
								images: this.form.pic,
								imagesThumb: this.form.imagesThumb,
								content: this.form.detail,
								brief: this.form.desc,
							},
						}).then((res) => {
							if (res.data.status == 200) {
								this.$message.success('添加成功');
								this.$router.push({
									path: '/home/article',
									query: {
										id: this.$route.query.id
									}
								})
							} else {
								this.$message.error(res.data.message);
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			}
		}
	}
</script>

<style scoped="scoped">
	/deep/ .el-form-item__label {
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
	}

	.line {
		width: 100%;
		height: 1px;
		background: #000000;
		opacity: 0.3;
	}

	.title {
		display: inline-block;
		padding: 30px 0 30px 0;
	}

	.titleTip {
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #000000;
		line-height: 24px;
	}
</style>



// WEBPACK FOOTER //
// src/views/content/article/artUpdate.vue